import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {ClientProcessorsModel} from "./client-processors.model";

@Injectable()
export class ClientProcessorsService implements IDataModel {

    private API_ROOT:string = '/clients/processor';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<ClientProcessorsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientProcessorsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/processor`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOneByClient(clientId:number): Observable<ResponseModel<ClientProcessorsModel>>  {
        return this.http.get(`/clients/${clientId}/processor`).map((res) => res.json());
    }


    getOne(id:number):Observable<ResponseModel<ClientProcessorsModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:ClientProcessorsModel): Observable<ResponseModel<ClientProcessorsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:ClientProcessorsModel): Observable<ResponseModel<ClientProcessorsModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/client-processors/client-processors.service.ts